import React from 'react';
import flag from '../../../src/assets/imgs/gh.svg';
import auth from "../../network/services/auth";
import {setUserAuth} from "../../helpers/authenticator";
import toastifyHelper from "../../helpers/toastify_helper";
import {ToastContainer} from "react-toastify";
import {useForm} from 'react-hook-form'
import {getErrorMessage, phoneNumberRegexPattern} from "../../helpers/general_helper";

const LoginForm = ({change}) => {
  const {register, handleSubmit, watch, errors} = useForm();

  const loader = () => {
    change.callback({
      isActive: true,
      componentType: "loading",
      phone: "",
      refId: ""
    });
  };


  const signIn = (data) => {
    loader();
    auth.userLoginWithoutOTP(data).then(response => {
      toastifyHelper.toastify.successToastify(response.data.message);
      setUserAuth(response.data.data);
      change.callback({
        isActive: false,
        componentType: "redirect",
        phone: "",
        refId: response.data.data.token
      })
    }).catch(error => {
      toastifyHelper.toastify.errorToastify(error.response.data.error);
      change.callback({
        isActive: false,
        componentType: "signin",
        phone: "",
        refId: ""
      })
    });
  };

  if (change.isClicked) {
    document.getElementById("button").click();
    change.buttonCallback(false)
  }

  return (
    <>
      <ToastContainer/>
      <div className="row justify-content-center">
        <div className="col-md-7 col-lg-5 col-sm-7">
          <form onSubmit={handleSubmit(signIn)}>
            <div className="text-left" style={{paddingLeft: 27, paddingRight: 27}}>
              <ul className="list-unstyled">
                <li><small>Phone number</small></li>
                <li style={{marginTop: 5}}>
                  <div className="input-group">
                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">
                                            <img style={{height: 14, marginRight: 5}} src={flag}
                                                 className="img-fluid"/> +233
                                    </span>
                    </div>
                    <input type="text" className="form-control form-control-lg input-form"
                           ref={register({
                             required: true,
                             min: 9,
                             max: 10,
                             pattern: phoneNumberRegexPattern()
                           })}
                           placeholder="Enter your phone number"
                           maxLength="10"
                           name="phone_number"
                           aria-label="Username" aria-describedby="basic-addon1"/>
                  </div>
                </li>
                <li>
                  {errors.phone_number &&
                  <small className="small-text-red"> <i
                    className="fas fa-exclamation-triangle"/>{getErrorMessage(errors.phone_number.type)}
                  </small>}
                </li>
                <li style={{marginTop: 15, marginBottom: 0}}><small>Password</small></li>
                <li style={{marginTop: 5}}>
                  <div className="input-group">
                    <input type="password" className="form-control form-control-lg input-form-alt"
                           ref={register({required: true, minLength: 5, maxLength: 20})}
                           placeholder="Password"
                           name="password"
                           aria-label="Username" aria-describedby="basic-addon1"/>
                  </div>
                </li>
                <li>
                  {errors.password &&
                  <small className="small-text-red"><i
                    className="fas fa-exclamation-triangle"></i>{getErrorMessage(errors.password.type)}
                  </small>}
                </li>
                <li className="text-right">
                  <input type="submit" id="button" style={{display: "none"}}/>
                </li>
              </ul>
            </div>
          </form>
        </div>
      </div>
    </>
  )
};

export default LoginForm;
